import { GetAffiliateResponse } from '../types/api/affiliate';
import { affiliateApi } from './base';

/**
 * RTK Query endpoints for affiliate-related API calls.
 */
export const affiliateEndpoints = affiliateApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Fetch affiliate details by affiliate ID (GUID).
     * Used when users land on quotation page via affiliate link (?aid=<GUID>).
     *
     * @param affiliateId - The affiliate GUID from URL query param
     * @returns Affiliate data including agentCode and agentBranchCode
     */
    getAffiliateDetails: builder.query<GetAffiliateResponse, string>({
      query: (affiliateId) => ({
        url: `/GetAffiliateData/${affiliateId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetAffiliateDetailsQuery, useLazyGetAffiliateDetailsQuery } =
  affiliateEndpoints;
